import { render, staticRenderFns } from "./MainWinwinExhibition.vue?vue&type=template&id=1eecc9a2&"
import script from "./MainWinwinExhibition.vue?vue&type=script&lang=js&"
export * from "./MainWinwinExhibition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports